import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

import { selectData } from '../selectors.ts';
import { useAttach } from '../useAttach';

import { userMeDraftStore } from './UserMeDraftStore';
import { userMeStore, type UserMeStoreState } from './UserMeStore';

export function useUserMeData() {
  useAttach(userMeStore, 'useUserMeData');
  return useStoreWithEqualityFn(userMeStore.store, selectData, shallow);
}
useUserMeData.store = userMeStore;

export function useUserMe() {
  useAttach(userMeStore, 'useUserMe');

  const draft = userMeDraftStore.store((state) => {
    return {
      userMe: state.userMe,
    };
  }, shallow);

  const select = useCallback(
    (state: UserMeStoreState) => {
      return {
        userMe: draft.userMe ?? state.userMe,
        userMeInstance: state.data,
        isLoading: state.isLoading,
        error: state.error,
      };
    },
    [draft.userMe],
  );

  const result = useStoreWithEqualityFn(userMeStore.store, select, shallow);

  return result;
}
useUserMe.store = userMeStore;

export function useUserMeAttach() {
  useAttach(userMeStore, 'useUserMeAttach');
}
useUserMeAttach.store = userMeStore;
